import {
  GET_CATEGORIES,
  GET_CATEGORIES_FAIL,
  GET_CATEGORIES_SUCCESS,
  CATEGORIES,
  CATEGORIES_FAIL,
  CATEGORIES_SUCCESS,
  GET_SUBCATEGORIES,
  GET_SUBCATEGORIES_SUCCESS,
  GET_SUBCATEGORIES_FAIL,
} from "./actionTypes";

/* Get categories */
export const getCategories = (data) => ({
  type: GET_CATEGORIES,
  payload: data,
});
export const getCategoriesSuccess = (data) => ({
  type: GET_CATEGORIES_SUCCESS,
  payload: data,
});
export const getCategoriesFail = (error) => ({
  type: GET_CATEGORIES_FAIL,
  payload: error,
});
/* Get Categories END */

/* New  categories */
export const cateGories = (data, callback) => ({
  type: CATEGORIES,
  payload: { data, callback },
});
export const cateGoriesFail = (error) => ({
  type: CATEGORIES_FAIL,
  payload: error,
});
export const cateGoriesSuccess = (data) => ({
  type: CATEGORIES_SUCCESS,
  payload: data,
});

/* New  Categories END */



// subcategories 

export const getSubCategories = (data, callback) => ({
  type: GET_SUBCATEGORIES,
  payload: { data, callback },
});
export const getSubCategoriesFail = (error) => ({
  type: GET_SUBCATEGORIES_FAIL,
  payload: error,
});
export const getSubCategoriesSuccess = (data) => ({
  type: GET_SUBCATEGORIES_SUCCESS,
  payload: data,
});
